/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react'
import CardHeader from '../../../../../components/CardHeader'
import UpdateButton from '../../../../../components/UpdateButton'
import Toast from '../../../../../components/Toast'
import WarningMessage from '../../../../../components/WarningMessage'
import TransactionData from '../TransactionData'
import Account from '../Account'
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId'
import moment from 'moment'
import { dataService } from '../../../../../services/data.services'
import GlobalContext from '../../../../../components/Context/GloablContext'
import { useNavigate } from 'react-router-dom'
import AnimatedModel from '../../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt'
import CustomOverLay from '../../../../../components/CustomOverlay'
import { useSelector } from 'react-redux'

export default function VoucherReceipt() {
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [toastErrorMessage, setToastErrorMessage] = useState('');
    const {setToastmessage, reloadFY, setReloadFY} = useContext(GlobalContext);
    const moment = require('moment');
    const currentDate = moment();
    let formattedDate = '';
    const fy = JSON.parse(localStorage.getItem('FY_details'));
    const fy_start_date = new Date(fy.start_date);
    const fy_end_date = new Date(fy.end_date);
    if ((currentDate >= fy_start_date && currentDate <= fy_end_date)) {
        formattedDate = currentDate.format('MMM DD,YYYY');
    }
    const [state, setState] = useState({transaction_date : formattedDate, description : ""})
    const [submitSelected, setsubmitSelected] = useState(false)
    const [errorMessage, setErrorMessage] = useState("");
    const newDestinationField = {account_id : "", account_name : "", account_number : "0.00"}
    const [destinationField, setDestinationField] = useState([newDestinationField])
    const [singleAccount, setSingleAccount] = useState("")
    const [singleAccountId, setSingleAccountId] = useState("");
    const [singleAccountNumber, setSingleAccountNumber] = useState("0.00");
    const [warningMessage, setWarningMessage] = useState("");
    const [loadingButton, setLoadingButton] = useState(false)
    const [accountNameError, setAccountNameError] = useState(false)
    const [amountError, setAmountError] = useState(false)
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const [dateError, setdateError] = useState(false)
    const navigate = useNavigate();
    const [loadingPage, setLoadingPage] = useState(true)
    const {userType} = useSelector((state)=>state.auth);

    /**
     * The function `handleValidation` checks if a transaction date is empty and if the description
     * length exceeds 100 words, setting error messages accordingly.
     * @returns The `handleValidation` function is returning a boolean value `isValid`, which indicates
     * whether the validation checks passed successfully. If all validation checks pass, `isValid` will
     * be `true`, otherwise it will be `false`.
     */
    const handleValidation = () => {
        let isValid = true;
        setToastErrorMessage("")
        if(state.transaction_date === "") {
            setdateError("date-error");
            setToastErrorMessage("Select Transaction Date")
            isValid = false;
        } 
        if(state.description.length > 100) {
            setToastErrorMessage('Description cannot exceed 100 words')
            isValid = false;
        } 
        return isValid;
    }

    /**
     * The function `handleAccountValidation` checks for empty fields, validates amounts, and ensures
     * total amounts match before allowing account validation.
     * @returns The function `handleAccountValidation` is returning a boolean value - either `true` or
     * `false` based on the conditions checked within the function.
     */
    const handleAccountValidation = () => {
        let emptyNameField = 0;
        let emptyAmount = 0;
        let totalAmount = 0;
        destinationField.map((item) => {
            if(item.account_id === "") {
                emptyNameField =emptyNameField + 1;
            }
            if(parseFloat(item.account_number).toFixed(2) === "0.00" || isNaN(parseFloat(item.account_number).toFixed(2))) {
                emptyAmount  = emptyAmount + 1
            }
            totalAmount += parseFloat(item.account_number)
        })
        if((emptyNameField !== 0 && (totalAmount === 0 || isNaN(totalAmount)) && (singleAccountNumber === "0.00" || isNaN(parseFloat(singleAccountNumber)) || parseFloat(singleAccountNumber) === 0))) {
            setToastErrorMessage("Please add at least one Source and Destination Account")
            setAccountNameError(true)
            return false
        } else if(emptyNameField !== 0 || singleAccountId === "") {
            setToastErrorMessage("Select Source/Destination Account")
            setAccountNameError(true)
            return false
        } else if(emptyAmount !== 0) {
            setToastErrorMessage("Amount must be greater than zero")
            setAmountError(true)
            return false
        }
        if(parseFloat(totalAmount).toFixed(2) !== parseFloat(singleAccountNumber).toFixed(2)) {
            setToastErrorMessage("Total Source Amount and Destination Amount must be equal")
            return false
        }
        return true
    }
    /**
     * The function `handleApiCall` is an asynchronous function that handles API calls for creating a
     * voucher entry in a financial system, including processing source and destination accounts and
     * displaying appropriate messages based on the API response or errors.
     */
    const handleApiCall = async() => {
        setLoadingButton(true)
        if(!(userType==='institution-user' || userType==='institution-admin')) {
            const branch_id = await GetBranchId()
            const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing&sort=status%2Basc`, true);
            if(res.data.data.ongoing !== JSON.parse(localStorage.getItem('FY_details')).name) {
                setToastErrorMessage(`You are not authorized to make entry for the${JSON.parse(localStorage.getItem('FY_details')).name}. Please refresh the page.`)
                return
            }
        }
        try {
            const branch_id = await GetBranchId();
            let destination_accounts = [];
            let accountTotal = 0;
            destinationField.map((item, index) => {
                destination_accounts.push({
                    source_account_id: item.account_id,
                    source_account: item.account_name,
                    source_amount: parseFloat(item.account_number)
                });
                accountTotal += parseFloat(item.account_number);
            });
            let body = {
                "branch_id": branch_id,
                "voucher_type": "receipt",
                "financial_year": JSON.parse(localStorage.getItem('FY_details')).name,
                "transaction_date": moment(state.transaction_date).format('YYYY-MM-DD'),
                "description": state.description,
                "source_accounts": destination_accounts,
                "destination_account_id": singleAccountId,
                "destination_account": singleAccount,
                "destination_amount": parseFloat(singleAccountNumber),
                "total_source_amount": parseFloat(accountTotal.toFixed(2))
            };
            let response = await dataService.PostAPI(body, 'voucher-entry');
            navigate("/accounting/voucher-entry")
            setToastmessage(response.data.data.message)
            setLoadingButton(false);
            setActivateButtonLoading(false)
        } catch (error) {
            setToastErrorMessage(error.response.data.message || error.message || "Something went wrong")
            console.error("An error occurred:", error);
            // Handle error here
            setActivateButtonLoading(false)
            setOpenConfirmation(false)
            setLoadingButton(false); // Consider whether setLoadingButton(false) should be inside or outside the catch block based on your requirements.
        }
    }
    /**
     * The handleSubmit function handles form submission by performing validation, checking account
     * validation, and making API calls based on certain conditions.
     */
    const handleSubmit = async() => {
        if(!handleValidation()) {
            setLoadingButton(false)
            setsubmitSelected(true)
        } else if(!handleAccountValidation()) {
            setLoadingButton(false)
        } else if((JSON.parse(localStorage.getItem('FY_details')).status === "open")){
            handelOpenFY() 
        } else {
            setLoadingButton(true)
            handleApiCall()  
        }
    }
    /**
     * The function `handelOpenFY` sets the `activateButtonLoading` state to `false` and the
     * `openConfirmation` state to `true`.
     */
    const handelOpenFY = async() => {
        setActivateButtonLoading(false)
        setOpenConfirmation(true)
    }
    /**
     * The function `handleFYSubmit` sets a loading state for a button and makes an API call.
     */
    const handleFYSubmit = () => {
        setActivateButtonLoading(true)
        handleApiCall()
    }

    useEffect(()=>{
        setReloadFY(false)
        setLoadingPage(true)
        setTimeout(() => {
            setLoadingPage(false)
        }, 500);
    }, [reloadFY])

    return (
        <CardHeader noPadding>
            <div class="mainDataCntnrTop shadow-s13" style={{position: "sticky", position: "-webkit-sticky"}}>
                <h5 class="pageHeader addclass">Add Voucher: Receipt</h5>
                <div class="flex items-center handleStudentSearchParams">
                    <UpdateButton
                        ButtonName={"Cancel"}
                        loading={false}
                        handleOnCLick={() => {navigate("/accounting/voucher-entry")}}
                        classKey="cancl-btn"
                    />
                    <UpdateButton
                        loading={loadingButton}
                        ButtonName={"Add"}
                        id={"add_contra"}
                        handleOnCLick={() => {handleSubmit()}}
                        classKey={"actn-btn onboardInstitution"}
                    />
                </div>
                {toastErrorMessage!=='' &&<Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
                {warningMessage !== "" && <WarningMessage 
                    warningMessage={warningMessage}
                    setWarningMessage={setWarningMessage}
                    fullMessage={true}

                />}
            </div>
            {loadingPage ? <div><CustomOverLay Active text="Loading ..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`} /></div>
                :<div className='mainDataCntnrPageDiv scrollBlue_thick'>
                    <div className='w-[100%] mx-auto'>
                        <TransactionData
                            state={state}
                            setToastErrorMessage={setToastErrorMessage}
                            setsubmitSelected={setsubmitSelected}
                            submitSelected={submitSelected}
                            setErrorMessage={setErrorMessage}
                            setState={setState}
                            dateError={dateError}
                            setdateError={setdateError}
                        />
                        <div className='flex justify-center mb-8 mt-6 w-[100%] mx-auto'>
                            <Account
                                AccountType={"Source"}
                                AccountOption={"multi"}
                                multiField={destinationField}
                                setMultiField={setDestinationField}
                                newMultiField={newDestinationField}
                                setWarningMessage={setWarningMessage}
                                setAccountNameError={setAccountNameError}
                                accountNameError={accountNameError}
                                amountError={amountError}
                                setAmountError={setAmountError}
                                setToastErrorMessage={setToastErrorMessage}
                                LegerEndpoint={"receipt"}
                                singleAccount={singleAccount}
                            />
                            <Account
                                AccountType={"Destination"}
                                AccountOption={"single"}
                                setSingleAccount={setSingleAccount}
                                singleAccount={singleAccount}
                                setSingleAccountId={setSingleAccountId}
                                setSingleAccountNumber={setSingleAccountNumber}
                                singleAccountNumber={singleAccountNumber}
                                setAccountNameError={setAccountNameError}
                                accountNameError={accountNameError}
                                amountError={amountError}
                                setAmountError={setAmountError}
                                setToastErrorMessage={setToastErrorMessage}
                                LegerEndpoint={"receipt"}
                                multiField={destinationField}
                                singleAccountId={singleAccountId}
                                classKey={" h-[162px] w-[410px]"}
                            />
                        </div>
                    </div>

                    {openConfirmation &&
                        <AnimatedModel
                            Children={
                                <ConfirmationPrompt
                                    handleOnCLickActivate={handleFYSubmit}
                                    handleClose={() => setOpenConfirmation(false)}
                                    crossMark
                                    additionalMessage={`A Voucher is being created for '${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})', which appears to be a back-dated entry.`}
                                    message={`Do you want to continue?`}
                                    buttonName={`Continue`}
                                    tittle={'Back Dated Entry'}
                                    dialogueWidth={'500px'}
                                    textPosition={'text-start'}
                                    loadingActivation={activateButtonLoading}
                                />
                            }
                        />
                    }
                </div>
            }
        </CardHeader>
    )
}
